import * as DG from 'datagrok-api/dg';
export async function getRdKitModule() {
    const funcList = DG.Func.find({ package: 'Chem', name: 'getRdKitModule' });
    if (funcList.length === 0)
        throw new Error('Package "Chem" must be installed for getRdKitModule.');
    const res = (await funcList[0].prepare().call()).getOutputParamValue();
    return res;
}
//# sourceMappingURL=rdkit-module.js.map